import React from 'react';
import Icon from '@lib/components/Icon';
import PropTypes from 'prop-types';

const SLIDER_COUNT = 4;

class SuccessStoriesTeaser extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            currentStory: 0,
            firstSlideIndex: 0,
        };
        this.setCurrentStory = this.setCurrentStory.bind(this);
    }

    render() {
        const { currentStory, firstSlideIndex } = this.state;
        const { stories } = this.props;
        // eslint-disable-next-line @typescript-eslint/no-unused-vars, react/prop-types
        const { image, overline, headline, headlineType, body, cta, tags } = stories[currentStory];
        const CustomHeadingTag = headlineType;
        const sliderStories = stories.slice(firstSlideIndex, SLIDER_COUNT);

        return (
            <div className="success-stories-teaser">
                <div className="success-stories-teaser__image">
                    <img className="image image--fill" src={image.src} alt={image.alt} />
                </div>
                <div className="success-stories-teaser__content">
                    <article className="blue-box">
                        <div className="overline">{overline}</div>
                        {headlineType ? (
                            <CustomHeadingTag className="h3">{headline}</CustomHeadingTag>
                        ) : (
                            <h3 className="h3">{headline}</h3>
                        )}
                        <div className="icon-tags">
                            {tags.map(({ icon, text }, index) => (
                                <div key={index} className="icon-tag">
                                    <div className="icon">
                                        <img src={icon} alt="" />
                                    </div>
                                    <div className="icon-tag__text">{text}</div>
                                </div>
                            ))}
                        </div>
                        <p className="body-copy">{body}</p>
                        {/*<a href={cta.link} className="button button--secondary">*/}
                        {/*    <span>{cta.text}</span>*/}
                        {/*    <Icon icon="arrow-right" />*/}
                        {/*</a>*/}
                    </article>
                </div>
                <div className="success-stories-teaser__slider-container">
                    <button
                        className="button button--icon is-size-2 success-stories-teaser__prev"
                        onClick={() => this.setCurrentStory(Math.max(currentStory - 1, 0))}
                        disabled={currentStory === 0}
                    >
                        <Icon icon="arrow-left" />
                    </button>
                    <div className="success-stories-teaser__slider">
                        {sliderStories.map(({ thumbnail, headline }, index) => (
                            <button
                                key={index + firstSlideIndex}
                                className={`success-stories-teaser-story ${
                                    currentStory === index + firstSlideIndex ? 'is-selected' : ''
                                }`}
                                aria-label={headline}
                                onClick={() => this.setCurrentStory(index + firstSlideIndex)}
                            >
                                <img className="image image--cover" src={thumbnail} alt="" />
                                <div className="overlay" />
                                <div className="success-stories-teaser-story__marker" />
                            </button>
                        ))}
                    </div>
                    <button
                        className="button button--icon is-size-2 success-stories-teaser__next"
                        onClick={() => this.setCurrentStory(Math.min(stories.length - 1, currentStory + 1))}
                        disabled={currentStory === stories.length - 1}
                    >
                        <Icon icon="arrow-right" />
                    </button>
                </div>
            </div>
        );
    }

    setCurrentStory(story) {
        this.setState(({ firstSlideIndex }) => {
            let newSlideIndex = firstSlideIndex;
            if (story < firstSlideIndex) {
                newSlideIndex = story;
            } else if (story >= firstSlideIndex + SLIDER_COUNT) {
                newSlideIndex = story - SLIDER_COUNT;
            }

            return {
                currentStory: story,
                firstSlideIndex: newSlideIndex,
            };
        });
    }
}

SuccessStoriesTeaser.propTypes = {
    stories: PropTypes.arrayOf(
        PropTypes.shape({
            image: PropTypes.shape({
                src: PropTypes.string.isRequired,
                alt: PropTypes.string,
            }).isRequired,
            overline: PropTypes.string.isRequired,
            headline: PropTypes.string.isRequired,
            body: PropTypes.string.isRequired,
            cta: PropTypes.shape({
                text: PropTypes.string.isRequired,
                link: PropTypes.string.isRequired,
            }),
            tags: PropTypes.arrayOf(
                PropTypes.shape({
                    icon: PropTypes.string.isRequired,
                    text: PropTypes.string.isRequired,
                })
            ).isRequired,
        })
    ).isRequired,
};

export default SuccessStoriesTeaser;
